var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"app"}},[(_vm.$data._isFetchingData)?_c('loader',{attrs:{"hide-scrollbar":true,"value":_vm.$data._percentComplete}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }